<div class="wrapper">
  <mat-card appearance="outlined" id="card">
    <app-file-upload *ngIf="step === 0" [modelUpload]="this"></app-file-upload>
    <app-editor *ngIf="step === 1" [modelUpload]="this"></app-editor>
    <app-summary #summary *ngIf="step === 2" [modelUpload]="this"></app-summary>
  </mat-card>
</div>
